import React from 'react';
import { Flex, Box, Text, Image } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/react';
import { GoPrimitiveDot } from 'react-icons/go';
import Link from 'next/link';
import moment from 'moment';
import { getStrapiMedia } from '../lib/media';

const Card = ({ article }) => {
  return (
    <Link
      href={`/article/${article.attributes.slug}`}
      style={{ textDecoration: 'none', color: 'black' }}
    >
      <Flex
        w={300}
        h={400}
        rounded="lg"
        overflow="hidden"
        m={10}
        borderWidth={1}
        shadow="md"
        direction="column"
        cursor="pointer"
        justifyContent={'space-between'}
      >
        <Box>
          <Image
            src={getStrapiMedia(article.attributes.image)}
            width={400}
            height={'auto'}
            alt="poster"
          />
        </Box>
        <Box p={5}>
          <Flex alignItems="center">
            <Icon color="#cf0032" as={GoPrimitiveDot} />
            <Text pr={1} fontSize={12} fontWeight="500" color="#cf0032">
              {moment(article.attributes.publishedAt).format('MMM DD, YYYY')}
            </Text>
          </Flex>
        </Box>
        <Box px={5}>
          <Text
            py={2}
            fontSize={14}
            fontWeight="900"
            noOfLines={2}
            overflow="hidden"
          >
            {article.attributes.title}
          </Text>
          <Text fontSize={12} fontWeight="300" noOfLines={3}>
            {article.attributes.description.length > 100
              ? article.attributes.description.substring(0, 100) + '...'
              : article.attributes.description}
          </Text>
          <Text cursor="pointer" py={5} fontWeight="900" fontSize={12}>
            Read more
          </Text>
        </Box>
      </Flex>
    </Link>
  );
};

export default Card;
